// extracted by mini-css-extract-plugin
export var disable = "Pagination-module--disable--7e105";
export var next = "Pagination-module--next--1cab8";
export var nextLink = "Pagination-module--nextLink--532ff";
export var pagination = "Pagination-module--pagination--d61cb";
export var previous = "Pagination-module--previous--4a76b";
export var previousLink = "Pagination-module--previousLink--5590d";